import {
	Avatar,
	Collapse,
	Divider,
	Grid,
	Hidden,
	IconButton,
} from "@mui/material";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import { ListItemButton } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import ListItemText from "@mui/material/ListItemText";
import { Theme } from "@mui/material/styles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import AddIcon from "@mui/icons-material/Add";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ClearIcon from "@mui/icons-material/Clear";
import ColorizeIcon from "@mui/icons-material/Colorize";
import { CognitoUser } from "amazon-cognito-identity-js";
import { fetchAuthSession, fetchUserAttributes } from "aws-amplify/auth";
// import { Storage } from "aws-amplify";
import React, { Fragment, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import config from "./../../amplifyconfiguration.json";
import { Amplify } from "aws-amplify";
Amplify.configure(config);

interface SideBarProps {
	onNavigate: () => void;
	menuVisible: boolean;
	user?: CognitoUser;
	onLogout: () => void;
}

export default function SideBar(props: SideBarProps) {
	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			drawer: {
				width: props.menuVisible
					? "100%"
					: (theme.components?.MuiDrawer?.styleOverrides?.root as any).width, //((theme as any).overrides?.MuiDrawer?.root as any)?.width,
				flexShrink: 0,
			},
			list: {
				marginTop: 25,
			},
			drawerPaper: {
				width: props.menuVisible
					? "100%"
					: (theme.components?.MuiDrawer?.styleOverrides?.root as any).width,
				color: "#fff",
				backgroundColor: theme.palette.success.main,
				zIndex: 1300,
			},
			icon: {
				color: "#fff",
			},
			// necessary for content to be below app bar
			toolbar: theme.mixins.toolbar,
			content: {
				flexGrow: 1,
				backgroundColor: theme.palette.background.default,
				padding: theme.spacing(3),
			},
			nestedItem: {
				paddingLeft: theme.spacing(4),
			},
			avatar: {
				height: 80,
				width: 80,
				cursor: "pointer",
			},
			capitalize: {
				textTransform: "capitalize",
				fontWeight: 600,
			},
			fontSize: {
				fontSize: 18,
			},
			avatarPadding: {
				padding: "10% 0",
			},
		})
	);

	const classes = useStyles();

	const [groups, setGroups] = useState<string[]>();
	const [userEmail, setUserEmail] = useState<string | undefined>("");
	// useEffect(() => {
	// 	setGroups(
	// 		props.user?.getSignInUserSession()?.getAccessToken().payload[
	// 			"cognito:groups"
	// 		]
	// 	);
	// 	props.user?.getUserAttributes((err, result) => {
	// 		setUserEmail(result?.find((a) => a.getName() === "email")?.getValue());
	// 	});
	// }, [props.user]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const sessionData = await fetchAuthSession();
				console.log("sessionData", sessionData);
				const userGroup =
					sessionData?.tokens?.idToken?.payload["cognito:groups"];
				console.log("userGroup", userGroup);
				// Check if userGroup is not null before setting it
				if (userGroup !== null) {
					setGroups(userGroup as string[]);
					const emailData = await fetchUserAttributes();
					console.log("emailData", emailData);
					const emailUser = emailData.email;
					console.log("emailuser", emailUser);
					setUserEmail(emailUser);
				} else {
					// If userGroup is null, set groups to undefined
					setGroups(undefined);
				}
			} catch (error) {
				console.error("Error fetching data:", error);
				// Handle error if needed
			}
		};

		fetchData();
	}, []);

	const [healthCareOpen, setHealthCareOpen] = React.useState(false);
	const handleHealthCareClick = () => {
		setHealthCareOpen(!healthCareOpen);
	};

	const [investigationOpen, setInvestigationOpen] = React.useState(false);
	const handleHInvestigationClick = () => {
		setInvestigationOpen(!investigationOpen);
	};

	const [testingOpen, setTestingOpen] = React.useState(false);
	const handleTestingClick = () => {
		setTestingOpen(!testingOpen);
	};

	const [hrOpen, setHROpen] = React.useState(false);
	const handleHRClick = () => {
		setHROpen(!hrOpen);
	};

	const [reportOpen, setReportOpen] = React.useState(false);
	const handleReportClick = () => {
		setReportOpen(!reportOpen);
	};

	const [otherOpen, setOtherOpen] = React.useState(false);
	const handleOpenClick = () => {
		setOtherOpen(!otherOpen);
	};
	const [helpOpen, setHelpOpen] = React.useState<boolean>(false);
	const handleOpenHelpClick = () => {
		setHelpOpen(!helpOpen);
	};
	const getUserNameFromEmail = (email: string) => {
		const fullName = email.split("@")[0];
		localStorage.setItem("fullName", fullName);
		return `${fullName.split(".")[0]} ${
			fullName.split(".")[fullName.split(".").length - 1]
		}`;
	};

	// const downloadHelpPdf = async () => {
	//   const link = document.createElement("a");
	//   link.href = (await Storage.get("resources/IDMSHelp.pdf")) as string;
	//   link.target = "_blank";
	//   document.body.appendChild(link);
	//   link.click();
	//   document.body.removeChild(link);
	// };
	// const downloadHelpPdfOne = async () => {
	//   const link = document.createElement("a");
	//   link.href = (await Storage.get("resources/IDMSHelpVTT.pdf")) as string;
	//   link.target = "_blank";
	//   document.body.appendChild(link);
	//   link.click();
	//   document.body.removeChild(link);
	// };
	// const downloadHelpPdfTwo = async () => {
	//   const link = document.createElement("a");
	//   link.href = (await Storage.get("resources/IDMSHelpVTR.pdf")) as string;
	//   link.target = "_blank";
	//   document.body.appendChild(link);
	//   link.click();
	//   document.body.removeChild(link);
	// };

	return (
		<Hidden mdDown={!props.menuVisible}>
			<Drawer
				className={classes.drawer}
				variant="permanent"
				classes={{
					paper: classes.drawerPaper,
				}}
				anchor="right"
			>
				<div>
					<Hidden mdUp>
						<IconButton onClick={props.onNavigate} size="large">
							<ClearIcon className={classes.icon} />
						</IconButton>
					</Hidden>
				</div>
				<Grid container justifyContent="center">
					<Grid item className={`${classes.capitalize} ${classes.fontSize}`}>
						{userEmail && getUserNameFromEmail(userEmail)}
					</Grid>
					<Grid container justifyContent="center">
						<Grid item className={classes.avatarPadding}>
							<RouterLink to="/profile" style={{ textDecoration: "none" }}>
								<Avatar className={`${classes.avatar} ${classes.capitalize}`}>
									{userEmail &&
										getUserNameFromEmail(userEmail)
											.split(" ")
											.map((name) => name[0])}
								</Avatar>
							</RouterLink>
						</Grid>
					</Grid>
				</Grid>
				<Grid container justifyContent="center">
					<Grid item>
						<Button
							variant="contained"
							onClick={props.onLogout}
							sx={{ ":hover": { bgcolor: "background.default" } }}
						>
							Logout
						</Button>
					</Grid>
				</Grid>
				<List className={classes.list}>
					{groups && groups.indexOf("Admin") >= 0 && (
						<RouterLink
							to="/admin"
							style={{ textDecoration: "none", color: "#fff" }}
						>
							<ListItemButton onClick={props.onNavigate}>
								<ListItemIcon>
									<SupervisorAccountIcon className={classes.icon} />
								</ListItemIcon>
								<ListItemText primary="Manage Users" />
							</ListItemButton>
						</RouterLink>
					)}
					{groups &&
						(groups.indexOf("Admin") >= 0 ||
							groups.indexOf("PowerUser") >= 0 ||
							groups.indexOf("SuperUser") >= 0) && (
							<RouterLink
								to="/log"
								style={{ textDecoration: "none", color: "#fff" }}
							>
								<ListItemButton onClick={props.onNavigate}>
									<ListItemIcon>
										<SupervisorAccountIcon className={classes.icon} />
									</ListItemIcon>
									<ListItemText primary="Log Record" />
								</ListItemButton>
							</RouterLink>
						)}
					{/* <RouterLink to="/" style={{ textDecoration: 'none', color: '#fff' }}>
                        <ListItemButton onClick={props.onNavigate}>
                            <ListItemIcon><AddIcon className={classes.icon} /></ListItemIcon>
                            <ListItemText primary="Intake" />
                        </ListItemButton>
                                </RouterLink>*/}
					<RouterLink
						to="/undergoingDevelopement"
						style={{ textDecoration: "none", color: "#fff" }}
					>
						<ListItemButton onClick={props.onNavigate}>
							<ListItemIcon>
								<AddIcon className={classes.icon} />
							</ListItemIcon>
							<ListItemText primary="View Residents" />
						</ListItemButton>
					</RouterLink>
					<RouterLink
						to="/directory"
						style={{ textDecoration: "none", color: "#fff" }}
					>
						<ListItemButton onClick={props.onNavigate}>
							<ListItemIcon>
								<AddIcon className={classes.icon} />
							</ListItemIcon>
							<ListItemText primary="Directory" />
						</ListItemButton>
					</RouterLink>
					<Divider />

					{groups &&
						(groups.indexOf("Admin") >= 0 ||
							groups.indexOf("ActiveEpisodes") >= 0 ||
							groups.indexOf("EhwcQueue") >= 0 ||
							groups.indexOf("AllEpisodes") >= 0 ||
							groups.indexOf("MostSevereTestResult") >= 0 ||
							groups.indexOf("MassAsymptomaticTesting") >= 0) && (
							<Fragment>
								<Collapse in={healthCareOpen} timeout="auto" unmountOnExit>
									<List component="div" disablePadding></List>
								</Collapse>
								<Divider />
							</Fragment>
						)}
					{groups &&
						(groups.indexOf("Admin") >= 0 ||
							groups.indexOf("MassAsymptomaticTesting")) >= 0 && (
							<Fragment>
								<Collapse in={testingOpen} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<RouterLink
											to="/testing/weekly-testing"
											style={{ textDecoration: "none", color: "#fff" }}
										>
											<ListItemButton
												onClick={props.onNavigate}
												className={classes.nestedItem}
											>
												<ListItemIcon>
													<ColorizeIcon className={classes.icon} />
												</ListItemIcon>
												<ListItemText primary="Input/ view data" />
											</ListItemButton>
										</RouterLink>
									</List>
									<List component="div" disablePadding>
										<RouterLink
											to="/testing/test-tracking"
											style={{ textDecoration: "none", color: "#fff" }}
										>
											<ListItemButton
												onClick={props.onNavigate}
												className={classes.nestedItem}
											>
												<ListItemIcon>
													<AssessmentIcon className={classes.icon} />
												</ListItemIcon>
												<ListItemText primary="Reports" />
											</ListItemButton>
										</RouterLink>
									</List>
								</Collapse>
								<Divider />
							</Fragment>
						)}
				</List>
			</Drawer>
		</Hidden>
	);
}
